import React from "react";
import type { StyleProp, ViewStyle } from "react-native";
import { View } from "react-native";
import { Hide, mq } from "react-native-unistyles";

import Button from "$src/core/components/atoms/Button/Button";
import useTranslation from "$src/core/hooks/use-translation";

import $ from "./SwimmingLanePreviousOverlay.web.styles";

export type SwimmingLanePreviousOverlayProps = {
  visible: boolean;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
};

const SwimmingLanePreviousOverlay = ({
  visible,
  onPress,
  style,
}: SwimmingLanePreviousOverlayProps) => {
  const { t } = useTranslation();

  $.useVariants({ visible });

  return (
    <Hide mq={mq.only.width(undefined, "lg")}>
      <View style={[$.overlay, style]}>
        <Button
          name="swimming_lane_previous"
          preset="secondary"
          icon="chevron-left"
          accessibilityLabel={t("COMMON/PREVIOUS/CTA/LABEL")}
          onPress={onPress}
        />
      </View>
    </Hide>
  );
};

export default SwimmingLanePreviousOverlay;
